import React from 'react'
import Title from '../layouts/Title'
import ProjectsCard from './ProjectsCard';
import { useData } from '../../config/DataContext';
import { motion } from 'framer-motion';
import { useNavigate } from "react-router-dom";

const Projects = ({ showAll = false }) => {
  const { projects } = useData();
  const navigate = useNavigate();
  const displayData = showAll ? projects : projects.slice(0, 6);

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.1 },
    },
  };

  return (
    <section id="projects" className="w-full py-8">
      <div className="flex justify-center items-center text-center mb-8">
        <Title title="Portfolio" des="My Projects" />
      </div>
      <motion.div
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: "-50px" }}
        className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4"
      >
        {displayData.map((items, index) => (
          <ProjectsCard
            key={items.key || index}
            title={items.pro_title}
            itemsDes={items.desList}
            src={items.pro_photo_list}
            githubLink={items.pro_github_link}
            androidLink={items.pro_website_link}
            webLink={items.pro_webApp_link}
            iosLink={items.pro_ios_app_link}
          />
        ))}
      </motion.div>

      {!showAll && projects.length > 6 && (
        <div
          className="flex justify-center items-center mt-8 cursor-pointer group"
          onClick={() => navigate("/projects")}
        >
          <span className="text-sm font-titleFont text-gray-400 group-hover:text-cyan-400 transition-all duration-300 mr-2">
            View All Projects
          </span>
          <span className="text-cyan-400 group-hover:translate-x-2 transition-transform duration-300">
            →
          </span>
        </div>
      )}
    </section>
  );
}

export default Projects
